import React, { useState } from 'react'
import { useParams } from 'react-router-dom'

// components
import SideViewModal from '../../../components/modals/SideViewModal/SideViewModal.component'
import EditPurchaseOrder from './EditPurchaseOrder.form'
import ActionButton from '../../../components/buttons/ActionButton/ActionButton.component'
import DeleteObjectWithModal from '../../../blockGroups/deletion/DeleteObjectWithModal/DeleteObjectWithModal.blockgroup'

// collections
import PurchaseOrderInfo from './collections/PurchaseOrderInfo.collection'
import PurchaseOrderHeader from './collections/PurchaseOrderHeader.collection'
import PurchaseOrderItemDetailsTable from './collections/PurchaseOrderDetailEquipment/PurchaseOrderItemDetailsTable.collection'

// forms
import EditPurchaseOrderFormController from './forms/EditPurchaseOrder.form.controller'
import PurchaseOrderDetailReceivingFormController from './forms/PurchaseOrderDetailReceiving.form.controller'

//apollo
import { GET_EQUIPMENT_PURCHASE_ORDER_BY_ID_WITH_ITEMS } from '../../../graphql/equipmentPurchaseOrder/equipmentPurchaseOrder.queries'
import { DELETE_EQUIPMENT_PURCHASE_ORDER } from '../../../graphql/equipmentPurchaseOrder/equipmentPurchaseOrder.mutations'

//Wrappers
import WithGqlQuery from '../../../wrappers/gql/WithGqlQuery/WithGqlQuery.wrapper';

// mui
import { Grid, Container } from '@mui/material'

// utils
import { createUserGroupList, checkIfUserHasGroup } from '../../../shared/privileges/userGroups'

export default function PurchaseOrderDetail({ usersGroups }) {
    const {orderId: orderIdParam} = useParams()
    const orderId = parseInt(orderIdParam)

    const groups = createUserGroupList(usersGroups)

    // modals
    const [showEdit, setShowEdit] = useState(false)
    const [showReceive, setShowReceive] = useState(false)
    
    return (<div id="PurchaseOrderDetail">
        <EditPurchaseOrderFormController 
            id={orderId}
            visible={showEdit}
            closeForm={() => setShowEdit(false)}
        />
        <PurchaseOrderDetailReceivingFormController 
            id={orderId}
            visible={showReceive}
            closeForm={() => setShowReceive(false)}
        />

        <PurchaseOrderHeader 
            id={orderId}
            editClickHandler={() => setShowEdit(true)}
            receiveClickHandler={() => setShowReceive(true)}
        />

        <Container maxWidth disableGutters sx={{ marginTop: 2 }}>
            <Grid container spacing={2} justifyContent='space-between'>
                <Grid item xs={4}><PurchaseOrderInfo id={orderId} /></Grid>
                <Grid item xs={8}></Grid>
            </Grid>
        </Container>

        <WithGqlQuery 
            component={PurchaseOrderItemDetailsTable} 
            query={GET_EQUIPMENT_PURCHASE_ORDER_BY_ID_WITH_ITEMS} 
            variables={{ id: orderId }} 
        />  

        {/* Delete button at bottom-left */}
        {
            checkIfUserHasGroup(groups, ['Admin']) &&
            <Container maxWidth={false} sx={{ marginTop: 4 }}>
                <DeleteObjectWithModal
                    id={orderId}
                    mutation={DELETE_EQUIPMENT_PURCHASE_ORDER}
                    deleteLabel={"Delete Purchase Order"}
                    deleteTitle={"Delete Purchase Order"}
                    deleteMessage={"Are you sure you want to delete this Purchase Order? This will delete all items associated with this order."}
                    successObjectKey="deleteEquipmentPurchaseOrder"
                    entityName="EquipmentPurchaseOrder"
                />
            </Container>
        }
        
    </div>)
}
